module.exports = __webpack_public_path__ + "static/media/rails.3247e1d0.svg";